// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-container {
  background-image: linear-gradient(135deg, #004658 0%, #027b9a 100%);
  padding: 3em;
  border-radius: 15px;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-top: 10%;
  margin-left: 20%;
  position: absolute;
  width: 50vw;
}

.auth-heading {
  font-size: 1.8rem;
  margin-bottom: 1.5em;
  color: #fff;
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);
}

.auth-form input {
  background: transparent;
  padding: 0.8em;
  border-radius: 30px;
  margin-bottom: 1.5em;
  width: 100%;
}


.auth-button {
  background: #004658;
  color: #027b9a;
  padding: 0.8em 2em;
  border: 2px solid #027b9a;
  border-radius: 30px;
  cursor: pointer;
  transition: 0.3s;
}

.auth-button:hover {
  background: #027b9a;
  color: #004658;
  padding: 0.8em 2em;
  border: 2px solid #004658;
}

.auth-button::placeholder {
  color: #027b9a;
}

.auth-button:hover::placeholder {
  color: #004658;
}

.auth-link {
  display: block;
  margin-top: 1em;
  color: #fff;
  font-size: 0.9rem;
  text-decoration: none;
}

.auth-link:hover {
  text-decoration: underline;
}

.auth-error {
  color: red;
  font-size: 0.9rem;
  margin-top: 1em;
}

.auth-success {
  color: green;
  font-size: 0.9rem;
  margin-top: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth/Auth.css"],"names":[],"mappings":"AAGA;EACE,mEAAmE;EACnE,YAAY;EACZ,mBAAmB;EACnB,mCAA2B;UAA3B,2BAA2B;EAC3B,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;;AAGA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500&display=swap');\n\n\n.auth-container {\n  background-image: linear-gradient(135deg, #004658 0%, #027b9a 100%);\n  padding: 3em;\n  border-radius: 15px;\n  backdrop-filter: blur(10px);\n  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  margin-top: 10%;\n  margin-left: 20%;\n  position: absolute;\n  width: 50vw;\n}\n\n.auth-heading {\n  font-size: 1.8rem;\n  margin-bottom: 1.5em;\n  color: #fff;\n  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.auth-form input {\n  background: transparent;\n  padding: 0.8em;\n  border-radius: 30px;\n  margin-bottom: 1.5em;\n  width: 100%;\n}\n\n\n.auth-button {\n  background: #004658;\n  color: #027b9a;\n  padding: 0.8em 2em;\n  border: 2px solid #027b9a;\n  border-radius: 30px;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.auth-button:hover {\n  background: #027b9a;\n  color: #004658;\n  padding: 0.8em 2em;\n  border: 2px solid #004658;\n}\n\n.auth-button::placeholder {\n  color: #027b9a;\n}\n\n.auth-button:hover::placeholder {\n  color: #004658;\n}\n\n.auth-link {\n  display: block;\n  margin-top: 1em;\n  color: #fff;\n  font-size: 0.9rem;\n  text-decoration: none;\n}\n\n.auth-link:hover {\n  text-decoration: underline;\n}\n\n.auth-error {\n  color: red;\n  font-size: 0.9rem;\n  margin-top: 1em;\n}\n\n.auth-success {\n  color: green;\n  font-size: 0.9rem;\n  margin-top: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
